import request from '@/utils/request'

export function gettasklist(query) {
	return request({
		url: 'api/gettasklist',
		method: 'get',
		params: query
	})
}

export function submittask(query) {
	return request({
		url: 'api/submittask',
		method: 'post',
		data: query
	})
}

export function submittalk(query) {
	return request({
		url: 'api/submittalk',
		method: 'post',
		data: query
	})
}

export function getmsglist(query) {
	return request({
		url: 'api/getmsglist',
		method: 'get',
		params: query
	})
}

export function sendmsg(query) {
	return request({
		url: 'api/sendmsg',
		method: 'post',
		data: query
	})
}

export function getleavemsglist(query) {
	return request({
		url: 'api/getleavemsglist',
		method: 'get',
		params: query
	})
}

export function submitleavemsg(query) {
	return request({
		url: 'api/submitleavemsg',
		method: 'post',
		data: query
	})
}

 

